import { render, staticRenderFns } from "./UVLogo.vue?vue&type=template&id=f372b620&scoped=true"
import script from "./UVLogo.vue?vue&type=script&lang=ts"
export * from "./UVLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f372b620",
  null
  
)

export default component.exports